module.exports = __webpack_public_path__ + "img/VideoCameraBackOutlined.523f93d4.svg";